import { create } from 'zustand';
import { createSelectors } from './createSelectors';
import { InventoriesSlice, createInventoriesSlice } from './slices/inventories';

const useInventoryPageBase = create<InventoriesSlice>((...a) => ({
	...createInventoriesSlice(...a),
}));

export const useInventoryPageStore = createSelectors(useInventoryPageBase);
